import req from '@sportninja/common/api/request'

/**
 * Resets a registration session by deleting it
 * @param sessionId - The ID of the session to reset
 */
export const resetRegistrationSession = async (sessionId: string) => {
  await req(`/registration/session/${sessionId}`, {
    method: 'DELETE',
  })
}
